import { render, staticRenderFns } from "./ParcelaCard.vue?vue&type=template&id=62ccea52"
import script from "./ParcelaCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ParcelaCard.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports